<template>
    <span :class="classes"
        class="tw-inline-flex tw-items-center tw-gap-1 tw-px-2 tw-py-0.5 tw-rounded-full tw-text-xs tw-font-semibold tw-border tw-border-solid tw-capitalize">
        <span class="tw-w-1.5 tw-h-1.5 tw-rounded-full" :class="dotClass"></span>
        {{ $t('portal.tickets.status-' + status) }}
    </span>
</template>

<script setup>
import { defineProps, computed } from 'vue';

const props = defineProps({ status: { type: String, default: 'open' } });

const map = {
    open: 'tw-bg-amber-50 tw-text-amber-700 tw-border-amber-200',
    answered: 'tw-bg-emerald-50 tw-text-emerald-700 tw-border-emerald-200',
    closed: 'tw-bg-gray-100 tw-text-gray-600 tw-border-gray-200',
};
const dots = {
    open: 'tw-bg-amber-500',
    answered: 'tw-bg-emerald-500',
    closed: 'tw-bg-gray-400',
};

const classes = computed(() => map[props.status] || map.open);
const dotClass = computed(() => dots[props.status] || dots.open);
</script>
